import { ICollectionsChatBundleRequest } from 'src/types/Collections';

import { getCollections, updateCollection, getCollectionDetail } from './agent';

class CollectionService {
    queryKey = 'collections';

    getPublicCollections = async (location?: string, tags?: string[]) => {
        try {
            const { data } = await getCollections({ is_public: true, location, tags });

            return Promise.resolve(data);
        } catch (error) {
            return Promise.reject(error);
        }
    };

    getAllCollections = async (location?: string, tags?: string[]) => {
        try {
            const { data } = await getCollections({ location, tags });

            return Promise.resolve(data);
        } catch (error) {
            return Promise.reject(error);
        }
    };

    getPrivateCollection = async (projectId: number) => {
        try {
            const { data } = await getCollections({ is_public: false, project_id: projectId });
            const bundle = data?.chat_bundles?.[0];
            if (!bundle?.id) {
                return Promise.resolve(data);
            }

            const { data: detail } = await getCollectionDetail(bundle.id);
            return Promise.resolve({
                ...data,
                chat_bundles: [detail, ...data.chat_bundles.slice(1)],
            });
        } catch (error) {
            return Promise.reject(error);
        }
    };

    updateCollection = async (collection: ICollectionsChatBundleRequest) => {
        try {
            const { data } = await updateCollection(collection);

            return Promise.resolve(data);
        } catch (error) {
            return Promise.reject(error);
        }
    };
}

export default new CollectionService();
